import { FC } from "react";
import CategoryStatusTable from "../CategoryStatusTable";
import useWorkerListCategoryStatus, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

const WorkerListCategoryStatusLayout: FC<Props> = () => {
  return (
    <Styles>
      <CategoryStatusTable nonEditable screen="workers" recordType="status" />
      <CategoryStatusTable screen="workers" recordType="category" />
    </Styles>
  );
};

const WorkerListCategoryStatus: FC<ReceivedProps> = (props) => (
  <WorkerListCategoryStatusLayout {...useWorkerListCategoryStatus(props)} />
);

export default WorkerListCategoryStatus;
